import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import styles from './PromoPageContainer.module.css';

export const PromoPageContainer = (props) => {
    const containerClass = clsx(
        styles.container,
        props.bgColor && `bg${props.bgColor.charAt(0).toUpperCase() + props.bgColor.slice(1)}`,
        !props.noIndent && styles.withPaddingBottom,
        props.hasTopPadding && styles.withTopPadding,
    );

    return (
        <div className={containerClass} data-testid={props.dataTestId}>
            {props.children}
        </div>
    );
};

PromoPageContainer.propTypes = {
    bgColor: PropTypes.oneOf(['white', 'purple5', 'gray5', 'eggshell01', 'eggshell02', 'eggshell03', 'baseColor']),
    noIndent: PropTypes.bool,
    hasTopPadding: PropTypes.bool,
};
